<template>
    <div class="box-welcome pt-14" data-cy="container_home_welcome_point">
        <div class="bg-welcome-point flex gap-8 mx-auto py-3">
            <div class="-mt-8 -ml-14">
                <img class="img-fish" :src="imgFishWelcome" data-cy="img_home_welcome_fish" />
            </div>
            <div class="-ml-8"
                :class="{'h-20 my-auto': !isShowPoint}">
                <div class="text-14 text-a-blue-2140a6 pt-2.5"
                    :class="{'pb-1': !isShowPoint}">
                    {{lbl.home.welcome_point.welcome}}
                </div>
                <div class="font-bold text-16 text-a-blue-2140a6"
                    v-if="isShowPoint && expiringPoint">
                    {{getPointMessage()}}
                </div>
                <div class="font-light text-10 text-a-red-ff4d4d py-1"
                    v-if="isShowPoint && expiringPoint">
                    {{lbl.home.welcome_point.expire}} {{FilterDateShortFormat(expiringPoint.dateExpire)}}
                </div>
                <div class="w-max flex justify-center items-center gap-1 bg-a-blue-e3e9fd border border-a-blue-c2cdf2 rounded-5 px-2 py-2 mt-1"
                    data-cy="btn_home_welcome_coupon"
                    @click="gotoCoupon()">
                    <div><img :src="icCoupon" data-cy="img_home_welcome_coupon_icon" /></div>
                    <div class="w-px h-3 bg-a-blue-8296d9"></div>
                    <div class="font-medium text-14 text-a-blue-2140a6">
                        {{lbl.home.welcome_point.my_coupon}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
//service
import BzbsPoint from '@/core/Point/service/BzbsPoint.js';
import ConfigManager from "@/config/ConfigManager.js";
export default {
    name: 'WelcomePoint',
    mixins: [LocaleMixin, AuthStatusMixin],
    props: {
        // props
        isShowPoint: { type: Boolean },
    },
    data: function(){
        return {
            expiringPoint: null,
            imgFishWelcome: null,
            icCoupon: null,
        }
    },
    created: function(){
        this.getExpiringPoint();
        this.imgFishWelcomeUrl();
    },
    methods: {
        getExpiringPoint: function() {
            BzbsPoint.apiExpiringPoint().subscribe({
                next: (data) => {
                    console.log('exp point', data);
                    this.expiringPoint = data;
                },
                error: (err) => {
                    this.errorApi(err);
                },
            })
        },
        getPointMessage: function () {
            var pointUnit = this.lbl.home.welcome_point.point_unit + (this.userPoint > 1 && this.localeCode == 1033 ? 's' : '');
            return this.lbl.home.welcome_point.you_have + " " + this.FilterNumberFormat(this.userPoint) + " " + pointUnit;
        },
        gotoCoupon: function(){
            this.tracking.event('home_my_rewards', 'click_cart', null, null);

            this.$router.push('/history');
        },
        imgFishWelcomeUrl: function() {
            var appId = ConfigManager.getAppId();
            this.imgFishWelcome = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/img-fish-welcome@3x.png`;
            this.icCoupon = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/ic-coupon.svg`;
        },
    }
}
</script>
 <style lang="scss" scoped>
.box-welcome{
    background: linear-gradient(
        to bottom,
        #002850 0%,
        #002850 50%,
        white 50%,
        white 100%
    );
}
.bg-welcome-point{
    width: 310px;
    height: 150px;
    background-image: url('../../../assets/bg/bg-welcome-point@3x.png');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 330px 145px;

    .img-fish{
        width: 150px;
        height: 160px;
        // margin-left: -20px;
    }
}
 </style>
